// Modules
import React from 'react'
import { DasaProvider } from '@dasa-health/components-react'
import { ThemeProvider } from '@dasa-health/alma-react'

// Application
import { AppProvider, RecoverPasswordProvider, SignUpProvider, AccountProvider } from 'context'

// Components
import { ContainerContent } from 'components/ContainerContent'
import { global as GlobalStyle } from 'styles/global'
import { navTheme } from 'theme'

type ContainerProviderProps = {
    children: JSX.Element | JSX.Element[]
}

export const ContainerProvider: React.FC<ContainerProviderProps> = ({ children }) => (
    <ThemeProvider theme={navTheme}>
        <AppProvider>
            <SignUpProvider>
                <RecoverPasswordProvider>
                    <AccountProvider>
                        <DasaProvider>
                            <GlobalStyle />
                            <ContainerContent>{children}</ContainerContent>
                        </DasaProvider>
                    </AccountProvider>
                </RecoverPasswordProvider>
            </SignUpProvider>
        </AppProvider>
    </ThemeProvider>
)
